<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Alterar dia de vencimento da cobrança
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <div v-if="inputError" class="alert alert-danger">
            {{ inputError }}
          </div>
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>Id</th>
                <td>{{ billing.id }}</td>
              </tr>
              <tr>
                <th>Dia atual</th>
                <td>{{ billing.due_day }}</td>
              </tr>
              <tr>
                <th>Instituição</th>
                <td>{{ billing.institution_name }}</td>
              </tr>
              <tr>
                <th>Curso</th>
                <td>{{ billing.course_name }}</td>
              </tr>
            </tbody>
          </table>

          <template v-if="canChangeDueDay && hasAvailableDays">
            <div class="modal-body">
              <div>
                <p>
                  Novo dia para as mensalidades:
                </p>
                <select v-model="selectedDay" @click="inputError = null" class="form-control">
                  <option v-for="day in availableDays" :key="day" :value="day">
                    {{ day }}
                  </option>
                </select>
              </div>
              <p class="modal-legend">
                <strong>
                  Nenhuma mensalidade
                </strong>
                será afetada por essa mudança.
                <strong>
                  Apenas a cobrança
                </strong>
                terá seu dia de vencimento alterado.
              </p>
            </div>
          </template>
          <template v-else>
            <div class="modal-body">
              <div class="alert alert-warning">
                <template v-if="!canChangeDueDay && canChangeDueDayByInstitution">
                  <p>
                    Aluno atualizou sua data de vencimento no dia <strong>{{ dueDayChangedAt }}</strong>.
                  </p>
                  <p>
                    Sua próxima alteração só poderá ser efetuada a partir do dia {{ canChangeDueDayAt }}.
                  </p>
                </template>
                <template v-else>
                  Alteração de vencimento indisponível ou não permitida pela Instituição.
                </template>
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" v-if="canChangeDueDay && hasAvailableDays" @click="changeBillDueDate">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BillingsService from 'services/BillingsService';
import moment from 'moment';

export default {
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedDay: this.billing.due_day,
      inputError: null,
    };
  },
  computed: {
    availableDays() {
      return this.billing.available_due_days;
    },
    canChangeDueDay() {
      return this.billing.can_change_due_day;
    },
    canChangeDueDayByInstitution() {
      return this.billing.allowed_change_due_day_by_institution;
    },
    canChangeDueDayAt() {
      return moment(this.billing.can_change_due_day_at).format('DD/MM/YYYY');
    },
    dueDayChangedAt() {
      return moment(this.billing.due_day_changed_at).format('DD/MM/YYYY');
    },
    hasAvailableDays() {
      return this.billing.available_due_days.length > 0;
    },
  },
  methods: {
    ...mapActions([
      'loadStudentBillings',
    ]),
    validateSelectedDay() {
      if (this.selectedDay === this.billing.due_day) {
        this.inputError = 'O novo dia de vencimento não pode ser igual ao atual';
        return false;
      }
      return true;
    },
    changeBillDueDate() {
      if (!this.validateSelectedDay()) {
        return;
      }
      this.$loader.show();
      BillingsService.changeDueDay(this.billing.id, this.selectedDay)
        .then(({ message }) => {
          this.$loader.hide();
          this.$emit('close');
          this.loadStudentBillings();
          this.$alert.notifySuccess(message);
        }).catch((error) => {
          this.$loader.hide();
          this.inputError = `Erro ao alterar dia de vencimento: ${error.message}`;
        });
    },
  },
};
</script>
